/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
  m11ReportSection08FoiChanged, m11ReportSection08ResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection08Foi, selectM11ReportSection08Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialAssessmentsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
  section08State, setAlertModalState, setStartingSection08State) => {

  let changesStates = {
    section08State: section08State
  };
  let response = await saveM11Changes(apiToken, 29, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    if (response.m11ReportContainerResource) {
      dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
    }
    if (response.m11ReportSection08Resource) {
      dispatch(m11ReportSection08ResourceChanged(response.m11ReportSection08Resource));
    }
    setStartingSection08State(JSON.parse(JSON.stringify(section08State)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const M11Step029TrialAssessmentsPart3 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection08Foi = useSelector(selectM11ReportSection08Foi);
  const m11ReportSection08Resource = useSelector(selectM11ReportSection08Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [section08State, setSection08State] = useState({
    "section87Status": "empty", "section87Xhtml": "",
    "section861Status": "empty", "section861Xhtml": "",
    "section862Status": "empty", "section862Xhtml": "",
    "section863Status": "empty", "section863Xhtml": "",
    "section88Status": "empty", "section88Xhtml": "",
    "section85Status": "empty", "section85Xhtml": ""
  });
  const [startingSection08State, setStartingSection08State] = useState({
    "section87Status": "empty", "section87Xhtml": "",
    "section861Status": "empty", "section861Xhtml": "",
    "section862Status": "empty", "section862Xhtml": "",
    "section863Status": "empty", "section863Xhtml": "",
    "section88Status": "empty", "section88Xhtml": "",
    "section85Status": "empty", "section85Xhtml": ""
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

  useImperativeHandle(ref, () => ({
    unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section08State, startingSection08State)),
    async saveAllChanges() {
      await saveTrialAssessmentsChanges(dispatch, apiToken, m11ResearchStudyFoi,
        section08State, setAlertModalState, setStartingSection08State);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section87Status": "empty", "section87Xhtml": "",
        "section861Status": "empty", "section861Xhtml": "",
        "section862Status": "empty", "section862Xhtml": "",
        "section863Status": "empty", "section863Xhtml": "",
        "section88Status": "empty", "section88Xhtml": "",
        "section85Status": "empty", "section85Xhtml": "",
        "loaded": true
      };
      setSection08State(startingData);
      setStartingSection08State(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[8]?.entry?.length) {
        let m11ReportSection008Foi = getIdFromReference(m11ReportContainerResource.section[8].entry[0]);
        if (m11ReportSection008Foi && !isNaN(m11ReportSection008Foi) && m11ReportSection008Foi !== m11ReportSection08Foi) {
          dispatch(m11ReportSection08FoiChanged(m11ReportSection008Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection08Foi && !isNaN(m11ReportSection08Foi)) {
      loadResource(m11ReportSection08Foi, "M11ReportSection08", apiToken, dispatch);
    }
  }, [m11ReportSection08Foi]);

  useEffect(() => {
    if (m11ReportSection08Resource && Object.keys(m11ReportSection08Resource).length > 0) {
      let startingData = {
        "section87Status": "empty", "section87Xhtml": "",
        "section861Status": "empty", "section861Xhtml": "",
        "section862Status": "empty", "section862Xhtml": "",
        "section863Status": "empty", "section863Xhtml": "",
        "section88Status": "empty", "section88Xhtml": "",
        "section85Status": "empty", "section85Xhtml": "",
        "loaded": true
      };
      if (m11ReportSection08Resource.section?.[0]?.section?.length > 0) {
        if (m11ReportSection08Resource.section[0].section[4]?.text?.div &&
          m11ReportSection08Resource.section[0].section[4].text.status !== "empty") {
          startingData.section85Status = m11ReportSection08Resource.section[0].section[4].text.status;
          startingData.section85Xhtml = m11ReportSection08Resource.section[0].section[4].text.div;
        }
        if (m11ReportSection08Resource.section[0].section[6]?.text?.div &&
          m11ReportSection08Resource.section[0].section[6].text.status !== "empty") {
          startingData.section87Status = m11ReportSection08Resource.section[0].section[6].text.status;
          startingData.section87Xhtml = m11ReportSection08Resource.section[0].section[6].text.div;
        }
        if (m11ReportSection08Resource.section[0].section[5]?.section?.length > 0) {
          if (m11ReportSection08Resource.section[0].section[5].section[0]?.text?.div &&
            m11ReportSection08Resource.section[0].section[5].section[0].text.status !== "empty") {
            startingData.section861Status = m11ReportSection08Resource.section[0].section[5].section[0].text.status;
            startingData.section861Xhtml = m11ReportSection08Resource.section[0].section[5].section[0].text.div;
          }
          if (m11ReportSection08Resource.section[0].section[5].section?.[1]?.text?.div &&
            m11ReportSection08Resource.section[0].section[5].section[1].text.status !== "empty") {
            startingData.section862Status = m11ReportSection08Resource.section[0].section[5].section[1].text.status;
            startingData.section862Xhtml = m11ReportSection08Resource.section[0].section[5].section[1].text.div;
          }
          if (m11ReportSection08Resource.section[0].section[5].section?.[2]?.text?.div &&
            m11ReportSection08Resource.section[0].section[5].section[2].text.status !== "empty") {
            startingData.section863Status = m11ReportSection08Resource.section[0].section[5].section[2].text.status;
            startingData.section863Xhtml = m11ReportSection08Resource.section[0].section[5].section[2].text.div;
          }
        }
        if (m11ReportSection08Resource.section[0].section[7]?.text?.div &&
          m11ReportSection08Resource.section[0].section[7].text.status !== "empty") {
          startingData.section88Status = m11ReportSection08Resource.section[0].section[7].text.status;
          startingData.section88Xhtml = m11ReportSection08Resource.section[0].section[7].text.div;
        }
        setSection08State(startingData);
        setStartingSection08State(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection08Resource]);

  return <div>
    <h3>Complete Section 8 Trial Assessments and Procedures</h3>
        {!(m11ReportSection08Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 29 (Complete Section 8 Trial Assessments and Procedures) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>
        {section08State.loaded && <>
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.5 Pharmacokinetics summary as needed.</h4>
          <TextDivEntry elementName="section85Xhtml"
            startingValue={section08State.section85Xhtml}
            setResourceState={setSection08State} />
          <div style={{ textAlign: "left" }}></div>
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.6.1 Genetics, Genomics, Pharmacogenetics, and Pharmacogenomics as needed.</h4>
          <TextDivEntry elementName="section861Xhtml"
            startingValue={section08State.section861Xhtml}
            setResourceState={setSection08State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.6.2 Pharmacodynamic Biomarkers as needed.</h4>
          <TextDivEntry elementName="section862Xhtml"
            startingValue={section08State.section862Xhtml}
            setResourceState={setSection08State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.6.3 Other Biomarkers as needed (optional).</h4>
          <TextDivEntry elementName="section863Xhtml"
            startingValue={section08State.section863Xhtml}
            setResourceState={setSection08State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.7 Immunogenicity Assessments summary as needed.</h4>
          <TextDivEntry elementName="section87Xhtml"
            startingValue={section08State.section87Xhtml}
            setResourceState={setSection08State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.8 Medical Resource Utilisation and Health Economics summary as needed.</h4>
          <TextDivEntry elementName="section88Xhtml"
            startingValue={section08State.section88Xhtml}
            setResourceState={setSection08State} />
        </>}
      </>
    }
  </div >
});

const M11Step029TrialAssessmentsPart3HelperText = <div>
  <h3>Complete Section 8 Trial Assessments and Procedures</h3>
  <div style={{ textAlign: "left" }}>
    <p>Enter data for Section 8.5 Pharmacokinetics.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Include any specific instructions for the collection and assay of samples and interpretation of PK assessments.</p>
      <p>Describe the biological samples collected, the handling of samples, and the assay method.	Specific sample collection and processing instructions can be described in an appendix or a separate document and cross referenced.</p>
      <p>Describe the retention time for the samples (ensuring alignment with the ICF).</p>
      <p>Indicate the types of analyses for each sample.</p>
      <p>Define the PK parameters to be calculated and the calculation methods.</p>
    </div>
    <p>Enter data for Section 8.6.1 Genetics, Genomics, Pharmacogenetics, and Pharmacogenomics.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Include any specific instructions for the collection and assay of samples for genetic, genomic, pharmacogenetic and/or pharmacogenomic analysis.</p>
      <p>Describe the biological samples that will be collected (e.g., tissue, serum, plasma), handling of samples, and the assay method. Specific sample collection and processing instructions can be described in an appendix or a separate document and cross referenced.</p>
      <p>Describe the retention time for the samples (ensuring alignment with the ICF).</p>
      <p>Indicate the types of analyses that may be studied for each sample.</p>
    </div>
    <p>Enter data for Section 8.6.2 Pharmacodynamic Biomarkers.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Include any specific instructions for the collection of samples and assessment of pharmacodynamic biomarkers.</p>
      <p>Describe the biological samples that will be collected (e.g., tissue, serum, plasma). Specific sample collection and processing instructions can be described in an appendix or a separate document and cross referenced.</p>
      <p>Describe the retention time for the samples (ensuring alignment with the ICF).</p>
      <p>Indicate the types of biomarkers that will be studied for each sample.</p>
      <p>Specify whether each sample is optional or required. Required samples must be based on a protocol objective.</p>
    </div>
    <p>If applicable, enter data for Section 8.6.3 Other Biomarkers.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Safety biomarkers should be included in Section 8.4 Safety Assessments and Procedures, and immunogenicity biomarkers should be included in Section 8.7 Immunogenicity Assessments.</p>
      <p>Include any specific instructions for the collection of samples and assessment of other biomarkers.</p>
      <p>Describe the biological samples that will be collected (e.g., tissue, serum, plasma). Specific sample collection and processing instructions can be described in an appendix or a separate document and cross referenced.</p>
      <p>Describe the retention time for the samples (ensuring alignment with the ICF).</p>
      <p>Indicate the types of biomarkers that will be studied for each sample.</p>
      <p>Specify whether each sample is optional or required. Required samples must be based on a protocol objective.</p>
    </div>
    <p>Enter data for Section 8.7 Immunogenicity Assessments.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Include any specific instructions for the collection of samples and interpretation of immunogenicity. If immunogenicity assessments are included within Section 8.3 Efficacy Assessments and Procedures or Section 8.4 Safety Assessments and Procedures, cross reference that section.</p>
      <p>Describe the biological samples that will be collected (e.g., tissue, serum, plasma). Specific sample collection and processing instructions can be described in an appendix or a separate document and cross referenced.</p>
      <p>Describe the retention time for the samples (ensuring alignment with the ICF).</p>
      <p>Indicate the types of biomarkers that will be studied for each sample.</p>
      <p>Specify whether each sample is optional or required. Required samples must be based on a protocol objective.</p>
    </div>
    <p>Enter data for Section 8.8 Medical Resource Utilisation and Health Economics.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>This section does not apply to COAs. Include this section only for any value evidence and outcomes assessments not included in either the efficacy or safety sections.</p>
      <p>Describe the health outcome measures, collection method (e.g., diary, physician interview), and participant burden.</p>
    </div>
    <p>Click the 'Save All Changes' button.</p>
  </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step029TrialAssessmentsPart3ValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 29, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 29 (Complete Section 8 Trial Assessments and Procedures) {validationCheckState.step29numberOfChecks} issues checked. {validationCheckState.step29numberPassed} passed. {validationCheckState.step29numberFailed} failed.</h4>
    <p>Section 8 heading is 'TRIAL ASSESSMENTS AND PROCEDURES': {validationCheckState.resultCheckSection8Heading}</p>
    <p>Section 8 TRIAL ASSESSMENTS AND PROCEDURES does not have text: {validationCheckState.resultCheckSection8Text}</p>
    <p>Section 8.5 heading is 'Pharmacokinetics': {validationCheckState.resultCheckSection85Heading}</p>
    <p>Section 8.5 Pharmacokinetics has content: {validationCheckState.resultCheckSection85Content}</p>
    <p>Section 8.6 heading is 'Biomarkers': {validationCheckState.resultCheckSection86Heading}</p>
    <p>Section 8.6 Biomarkers does not have text: {validationCheckState.resultCheckSection86Content}</p>
    <p>Section 8.6.1 heading is 'Genetics, Genomics, Pharmacogenetics, and Pharmacogenomics' or 'Genetics and Pharmacogenomics': {validationCheckState.resultCheckSection861Heading}</p>
    <p>Section 8.6.1 Genetics, Genomics, Pharmacogenetics, and Pharmacogenomics has content: {validationCheckState.resultCheckSection861Content}</p>
    <p>Section 8.6.2 heading is 'Pharmacodynamic Biomarkers': {validationCheckState.resultCheckSection862Heading}</p>
    <p>Section 8.6.2 Pharmacodynamic Biomarkers has content: {validationCheckState.resultCheckSection862Content}</p>
    <p>If present, Section 8.6.3 heading is 'Other Biomarkers': {validationCheckState.resultCheckSection863Heading}</p>
    <p>If present, Section 8.6.3 Other Biomarkers has content: {validationCheckState.resultCheckSection863Content}</p>
    <p>Section 8.7 heading is 'Immunogenicity Assessments': {validationCheckState.resultCheckSection87Heading}</p>
    <p>Section 8.7 Immunogenicity Assessments has content: {validationCheckState.resultCheckSection87Content}</p>
    <p>Section 8.8 heading is 'Medical Resource Utilisation and Health Economics': {validationCheckState.resultCheckSection88Heading}</p>
    <p>Section 8.8 Medical Resource Utilisation and Health Economics has content: {validationCheckState.resultCheckSection88Content}</p>
    </div>}  </div>
}

export default M11Step029TrialAssessmentsPart3;
export { M11Step029TrialAssessmentsPart3HelperText, M11Step029TrialAssessmentsPart3ValidationCheck };